import React, { useState, useEffect } from 'react';

const TestFlightBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Check if banner was already dismissed
    const wasDismissed = localStorage.getItem('testFlightBannerDismissed');
    if (wasDismissed === 'true') {
      setDismissed(true);
      return;
    }

    // Detect iOS devices
    const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
    const isInStandaloneMode = ('standalone' in window.navigator) && (window.navigator as any).standalone;

    // Show banner only on iOS and not in standalone mode (PWA)
    if (isIOS && !isInStandaloneMode) {
      setVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    setVisible(false);
    localStorage.setItem('testFlightBannerDismissed', 'true');
    setDismissed(true);
  };

  if (!visible || dismissed) {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      padding: '16px',
      background: 'linear-gradient(to bottom, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.98) 100%)',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      borderTop: '0.5px solid rgba(0,0,0,0.1)',
      boxShadow: '0 -10px 40px rgba(0,0,0,0.08)'
    }}>
      <div style={{
        maxWidth: '500px',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
      }}>
        {/* App Icon */}
        <div style={{
          flexShrink: 0,
          width: '56px',
          height: '56px',
          borderRadius: '12px',
          overflow: 'hidden',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          backgroundColor: '#fff'
        }}>
          <img
            src="/app-icon.png"
            alt="MXR Space"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
        </div>

        {/* Content */}
        <div style={{
          flex: 1,
          minWidth: 0
        }}>
          <div style={{
            fontSize: '16px',
            fontWeight: 600,
            color: '#000',
            marginBottom: '2px',
            letterSpacing: '-0.2px'
          }}>
            MXR Space
          </div>
          <div style={{
            fontSize: '11px',
            color: '#666',
            lineHeight: '1.3',
            whiteSpace: 'nowrap'
          }}>
            Jetzt auch als native iOS App
          </div>
        </div>

        {/* Buttons */}
        <div style={{
          display: 'flex',
          gap: '8px',
          alignItems: 'center'
        }}>
          <a
            href="https://testflight.apple.com/join/uSJTfZ6a"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '8px 16px',
              backgroundColor: '#007AFF',
              color: '#fff',
              fontSize: '14px',
              fontWeight: 600,
              borderRadius: '20px',
              textDecoration: 'none',
              border: 'none',
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              transition: 'all 0.2s ease',
              boxShadow: '0 2px 8px rgba(0,122,255,0.3)'
            }}
            target="_blank"
            rel="noopener noreferrer"
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#0051D5';
              e.currentTarget.style.transform = 'scale(1.02)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = '#007AFF';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            LADEN
          </a>
          <button
            onClick={handleDismiss}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '28px',
              height: '28px',
              padding: 0,
              backgroundColor: 'transparent',
              border: 'none',
              cursor: 'pointer',
              fontSize: '20px',
              color: '#8E8E93',
              transition: 'color 0.2s ease'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.color = '#000';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.color = '#8E8E93';
            }}
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
};

export default TestFlightBanner;
